module.exports = __webpack_public_path__ + "img/bg-aula.a9e52a47.svg";